<template>
  <div class="h-full flex flex-col">
    <div
      class="px-5 h-12 w-full flex bg-white border-b border-orange-lighter items-center text-black"
    >
      <ReportsSM />
    </div>
    <perfect-scrollbar class="h-full">
      <router-view class="px-5 pt-5 bg-white border-l border-r"></router-view>
    </perfect-scrollbar>
  </div>
</template>

<script>
import ReportsSM from "./ReportsSM";
export default {
  name: "Reports",
  components: { ReportsSM }
};
</script>
